import React, { FunctionComponent } from 'react';

interface AppLayoutProps {}

const AppLayout: FunctionComponent<AppLayoutProps> = ({ children }) => {


    return (
        <div className="app__background">
            <div className="form__container">
                <main className="container container--app">{children}</main>
            </div>
        </div>
    )
}

export default AppLayout;